import { Turnstile } from '@marsidev/react-turnstile';
import { TurnstileAction } from 'dg-web-shared/lib/TurnstileActions';
import { TextField } from './TextField';
import { texts } from '../i18n';
import { Colors } from './vars';
import { css } from '@emotion/css';
import { ButtonContainer, TextButton } from './TextButton';
import { useState } from 'react';
import { Language } from 'dg-web-shared/lib/Localized.ts';

export function ResetPasswordForm({
    suggestedUsername,
    onCancel,
    onSubmit,
    language,
}: {
    suggestedUsername: string;
    onCancel: () => void;
    onSubmit: (username: string, turnstileToken: string) => void;
    language: Language;
}) {
    const [username, setUsername] = useState(suggestedUsername);
    const [usernameEdited, setUsernameEdited] = useState(false);
    const [turnstileToken, setTurnstileToken] = useState<string | null>(null);

    function submit(): void {
        if (username.length > 0 && turnstileToken !== null) {
            onSubmit(username, turnstileToken);
        }
    }

    const isValid = username.length > 0 && turnstileToken !== null;

    return (
        <div className={style}>
            <TextField
                inputType="text"
                label={texts[language].username}
                value={username}
                onChange={setUsername}
                onBlur={() => setUsernameEdited(true)}
                onEnter={submit}
                errorText={
                    usernameEdited && username.length === 0
                        ? texts[language].requiredField
                        : ''
                }
            />

            <div className={css({ marginTop: '24px' })}>
                <Turnstile
                    siteKey={'0x4AAAAAABatiRYriPvAMuT9'}
                    options={{
                        theme: 'light',
                        size: 'flexible',
                        action: TurnstileAction.OPERATOR_RESET_PASSWORD,
                    }}
                    onError={() => setTurnstileToken(null)}
                    onExpire={() => setTurnstileToken(null)}
                    onSuccess={setTurnstileToken}
                />
            </div>

            <div className={css({ marginTop: '36px' })}>
                <ButtonContainer>
                    <TextButton
                        onClick={onCancel}
                        label={texts[language].cancel}
                    />

                    <TextButton
                        onClick={submit}
                        label={texts[language].submit}
                        disabled={!isValid}
                    />
                </ButtonContainer>
            </div>
        </div>
    );
}

const style = css`
    margin: 24px 10px;
    padding: 0px 40px;

    & [data-error='true'] {
        color: ${Colors.red};
    }
`;
